<template>
	<div class="ccs-logo-product-info">

		<div class="ccs-logo-product-info-image">
			<div class="ccs-logo-product-info-image-wrapper">
				<link-wrapper :href="product.url" :target="options.target" :hide-link="!showLink" @click="linkClick">
					<img :src="product.image" :alt="product.title"/>
				</link-wrapper>
			</div>
		</div>

		<div class="ccs-logo-product-info-main">
			<div class="ccs-logo-product-info-details" :class="{ 'ccs-learn-more-shown': showLearnMoreDescription }">
				<div class="ccs-logo-product-info-title">
					<link-wrapper :href="product.url" :target="options.target" :hide-link="!showLink" @click="linkClick">
						<h4 v-html="product.title"></h4>
					</link-wrapper>
				</div>

				<div class="ccs-logo-product-info-description" v-html="product.description"></div>

				<learn-more v-if="showLearnMoreDescription" :href="product.url" @click="linkClick" />
			</div>

			<div class="ccs-logo-product-info-buy">
				<price :price="product.price" />
				<quantity v-if="showAtc && showQty" :productId="product.productId" @changed="updateQty"/>
				<add-to-cart v-if="showAtc" :atc="product.atc" @click="atcClick" />
				<learn-more v-if="showLearnMoreAtc" :href="product.url" @click="linkClick" />
			</div>
		</div>

	</div>
</template>

<script>
	import linkWrapper from "link-wrapper.vue";
	import price from "./price.vue"
	import addToCart from "./add-to-cart.vue"
	import learnMore from "./learn-more.vue"
	import quantity from "./quantity.vue"

	export default {
		components: { linkWrapper, price, addToCart, learnMore, quantity },

		props: {
			product: {
				type: Object,
				required: true
			},
			logEvent: Function
		},

		inject: ["options"],

		computed: {
			showLink() {
				return !this.options.hideLinkIfNoPrice || this.product.price.value;
			},

			showAtc() {
				return this.product.atc && (!this.options.hideAtcIfNoPrice || this.product.price.value);
			},

			showQty() {
				return this.product.showQuantity;
			},

			showLearnMoreAtc() {
				return this.options.learnMoreMode === "atc"
					&& this.showLink
					&& !this.showAtc
					&& !this.product.price.loading;
			},

			showLearnMoreDescription() {
				return this.options.learnMoreMode === "desc" && this.showLink;
			}
		},

		methods: {
			linkClick() {
				this.logEvent(this.product, "conversion", "product", this.getProductInfo());
			},

			atcClick() {
				this.logEvent(this.product, "conversion", "addtocart", this.getProductInfo());
			},

			getProductInfo() {
				var product = {
					price: this.product.price.value,
					dynamicPrice: !!this.options.parsingPriceJs
				}
				if (this.showQty && this.showAtc) {
					product.quantity = this.product.quantity;
				}
				return product;
			},

			updateQty(qty) {
				this.product.quantity = qty;
			}
		}
	}
</script>

<style scoped>
	.ccs-logo-product-info {
		display: flex;
		margin: 1.5em 0;
		padding: 0 .5em;
		height: 17.85em;
	}

	.ccs-logo-product-info-image {
		display: flex;
		align-items: center;
		max-width: 33%;
	}

		.ccs-logo-product-info-image img {
			-webkit-user-drag: none;
			max-width: 100%;
			max-height: 15.7em;
			vertical-align: middle;
			overflow: hidden;
		}

	.ccs-logo-product-info-image-wrapper {
		width: 17.85em;
		margin: auto;
		text-align: center;
	}

	.ccs-logo-product-info-main {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex-grow: 1;
		flex-shrink: 100;
		width: 100%; /* ie */
		padding: 0 0 0 1em;
	}

	.ccs-logo-product-info-details {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
	}

		.ccs-logo-product-info-details .ccs-logo-learn-more {
			align-self: flex-start;
			font-size: .95em;
			line-height: 1em;
			margin-top: 0.5em;
		}

	.ccs-logo-product-info-title {
		align-self: flex-start;
		width: 100%; /* ie */
		color: black;
	}

		.ccs-logo-product-info-title a {
			text-decoration: none;
			color: currentColor;
		}

		.ccs-logo-product-info-title h4 {
			margin: 0.7em 0;
			font-size: 1.3em;
			line-height: 1.3em;
			max-height: 3.9em;
			overflow: hidden;
			transition: color .3s;
		}

	.ccs-logo-product-info-description {
		line-height: 1.4em;
		max-height: 8.4em; /* 6 lines */
		overflow-y: auto;
	}

	.ccs-logo-product-info-buy {
		display: flex;
		flex-shrink: 0;
		flex-wrap: wrap;
		justify-content: flex-end;
		align-items: center;
		margin-top: 1em;
	}

		.ccs-logo-product-info-buy .ccs-logo-learn-more {
			display: inline-block;
			padding: .65em 1.05em;
			background: #999;
			color: #fff;
			font-size: 1.15em;
			font-weight: bold;
			text-decoration: none;
			line-height: 1;
		}

			.ccs-logo-product-info-buy .ccs-logo-learn-more:hover,
			.ccs-logo-product-info-buy .ccs-logo-learn-more:focus {
				background: #888;
			}

	/* SMALL */

	.ccs-small .ccs-logo-product-info {
		flex-direction: column;
		height: auto;
	}

	.ccs-small .ccs-logo-product-info-image {
		max-width: 100%;
		text-align: center;
	}

		.ccs-small .ccs-logo-product-info-image img {
			width: auto;
		}

	.ccs-small .ccs-logo-product-info-main {
		justify-content: flex-start;
		padding: 0;
	}

	/*
		HOVER
	*/
	.ccs-logo-ls-popup .ccs-logo-product-info {
		padding: 0 1em;
	}
</style>
